import { render, staticRenderFns } from "./CrystalViolet_ResultsAB.vue?vue&type=template&id=b4d54084&"
import script from "./CrystalViolet_ResultsAB.vue?vue&type=script&lang=js&"
export * from "./CrystalViolet_ResultsAB.vue?vue&type=script&lang=js&"
import style0 from "./CrystalViolet_ResultsAB.vue?vue&type=style&index=0&id=b4d54084&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
